import React from 'react';
import { useRecoilValue } from 'recoil';
import Input from '~/components/molecule/Input';
import { pointerSelector } from '~/components/page/Forms/components/Builder/state/nodesAndEvents';

const text = {
  valueLabel: 'Waarde uit scherm',
};
type Props = { pointer: Array<string>; onFocus: () => void };

const PointerRenderer: React.FCC<Props> = ({ pointer, onFocus }) => {
  const resolvedPointerName = useRecoilValue(
    pointerSelector([pointer[0], pointer[1]]),
  );

  return (
    <Input
      type="text"
      width="100%"
      label={text.valueLabel}
      value={resolvedPointerName}
      onFocus={onFocus}
      readOnly
    />
  );
};

export default PointerRenderer;
